// extracted by mini-css-extract-plugin
export default {"Wrapper":"PopupInformation_Wrapper__NvFVF","content":"PopupInformation_content__AYMCc"};